export default __webpack_public_path__ + "static/media/hrm1.d787a298.svg";